// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nm-card {
  width: 540px;
}

.nm-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  padding: 12px 16px;
}

.nm-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 0;
}

.nm-list {
  max-height: 400px;
  overflow-y: auto;
}

.nm-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.nm-item:last-child {
  border-bottom: none;
}

.nm-item--clickable {
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.nm-item--clickable:hover {
  background-color: #f5f7fa;
}

.nm-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.nm-ititle {
  font-size: 14px;
  font-weight: 400;
}

.nm-ititle.is-unread {
  text-decoration: underline;
  font-weight: 600;
}

.nm-time {
  font-size: 12px;
  color: #999;
}

.nm-body {
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nm-empty {
  padding: 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/NotificationMenu.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;AACX","sourcesContent":[".nm-card {\n  width: 540px;\n}\n\n.nm-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  padding: 12px 16px;\n}\n\n.nm-divider {\n  height: 1px;\n  background-color: #e0e0e0;\n  margin: 0;\n}\n\n.nm-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.nm-item {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.nm-item:last-child {\n  border-bottom: none;\n}\n\n.nm-item--clickable {\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.nm-item--clickable:hover {\n  background-color: #f5f7fa;\n}\n\n.nm-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.nm-ititle {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.nm-ititle.is-unread {\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n.nm-time {\n  font-size: 12px;\n  color: #999;\n}\n\n.nm-body {\n  font-size: 13px;\n  color: #666;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.nm-empty {\n  padding: 16px;\n  text-align: center;\n  color: #999;\n  font-size: 14px;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
